const defaultConfig = {
  delete: {
    title: "Delete",
    text: "Are you sure you want to delete? You cannot undo this action.",
    showCancelButton: true,
    imageUrl: "delete.svg",
    imageWidth: 55,
    imageAlt: "Delete",
    buttonsStyling: false,
    customClass: {
      confirmButton: "btn btn-danger mx-2 btn-lg",
      cancelButton: "btn btn-outline-grey btn-outline-primary mx-2 btn-lg",
    },
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "No, cancel!",
    reverseButtons: true,
  },
  confirm: {
    title: "",
    text: "",
    showCancelButton: true,
    imageUrl: "warning.svg",
    imageWidth: 55,
    imageAlt: "",
    customClass: {
      confirmButton: "btn btn-primary mx-2 btn-lg px-5",
      cancelButton: "btn btn-outline-grey btn-outline-primary mx-2 btn-lg",
    },
    confirmButtonText: "Yes",
    cancelButtonText: "No, cancel!",
    buttonsStyling: false,
    reverseButtons: true,
  },
  cancel: {
    title: "",
    text: "",
    showCancelButton: true,
    imageUrl: "warning.svg",
    imageWidth: 55,
    imageAlt: "",
    customClass: {
      confirmButton: "btn btn-primary mx-2 btn-lg px-5",
      cancelButton: "btn btn-outline-grey btn-outline-primary mx-2 btn-lg px-5",
    },
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    buttonsStyling: false,
    reverseButtons: true,
  },
  duplicate: {
    title: "Duplicate",
    text: "Are you sure you want to duplicate ?",
    showCancelButton: true,
    imageUrl: "duplicate.svg",
    imageWidth: 55,
    imageAlt: "Duplicate",
    customClass: {
      confirmButton: "btn btn-primary mx-2 btn-lg",
      cancelButton: "btn btn-outline-grey btn-outline-primary mx-2 btn-lg",
    },
    confirmButtonText: "Yes, Duplicate",
    cancelButtonText: "No, cancel!",
    buttonsStyling: false,
    reverseButtons: true,
  },
  denied: {
    title: "Success",
    text: "",
    buttonsStyling: false,
    customClass: {
      confirmButton: "btn btn-primary btnw-170",
    },
    type: "warning",
  },
  common: {
    title: "Success",
    text: "Action completed successfully",
    buttonsStyling: false,
    scrollbarPadding: false,
    customClass: {
      confirmButton: "btn btn-primary btnw-100",
    },
    type: "success",
  },
  ok: {
    title: "Success",
    scrollbarPadding: false,
    text: "Action completed successfully",
    buttonsStyling: false,
    customClass: {
      confirmButton: "btn btn-primary btnw-170",
    },
  },
};

const getConfig = function (config) {
  var newConf = {};
  if (
    ["success", "error", "warning", "info", "question"].includes(
      config.alertType
    )
  ) {
    newConf = Object.assign(newConf, defaultConfig.common);
    newConf.type = config.alertType;
  } else {
    newConf = Object.assign(newConf, defaultConfig[config.alertType]);
  }
  newConf = Object.assign(newConf, config);
  if (newConf.alertType) {
    delete newConf.alertType;
  }
  if (newConf.imageUrl) {
    newConf.imageUrl = require("@/assets/img/icons/" + newConf.imageUrl);
  }
  return newConf;
};

const showDialogue = function (Vue, config) {
  return Vue.swal(config);
};

const CustomSweetAlert = {
  install(Vue) {
    Vue.prototype.$showConfirm = function (title, text, type, params = {}) {
      params.title = title;
      // params.text = text
      params.html = text;
      params.alertType = type;
      params.allowOutsideClick = false;
      params.showLoaderOnConfirm = true;
      var types = [
        "denied",
        "cancel",
        "delete",
        "confirm",
        "duplicate",
        "success",
        "error",
        "warning",
        "info",
        "question",
        "ok",
      ];
      if (!types.includes(params.alertType)) {
        throw new Error(`alert type "${params.alertType}" not allowed`);
      }
      var deleteConfig = getConfig(params);

      return showDialogue(Vue, deleteConfig);
    };
  },
};

export default CustomSweetAlert;
